// Google Tag Manager

// Shopping Behaviour Analysis - 'Sessions with Product Views'
export const productView = id => {
  const { dataLayer } = window;

  const ecommerceData = {
    event: 'productView',
    ecommerce: {
      detail: {
        products: [
          {
            id
          }
        ]
      }
    }
  };

  dataLayer.push(ecommerceData);
};

// Shopping Behaviour Analysis - 'Sessions with Add to Basket'
export const chooseImage = id => {
  const { dataLayer } = window;

  const ecommerceData = {
    event: 'chooseImage',
    ecommerce: {
      add: {
        products: [
          {
            id
          }
        ]
      }
    }
  };

  dataLayer.push(ecommerceData);
};

// Shopping Behaviour Analysis - 'Sessions with Check-Out'
// Checkout Behaviour Analyisis - Checkout Funnel Step 1
export const buyNow = id => {
  const { dataLayer } = window;

  const ecommerceData = {
    event: 'buyNow',
    ecommerce: {
      checkout: {
        actionField: { step: 1, option: 'option' },
        products: [
          {
            id
          }
        ]
      }
    }
  };

  dataLayer.push(ecommerceData);
};

// Checkout Behaviour Analyisis - Checkout Funnel Step 2
export const purchaseCredits = () => {
  const { dataLayer } = window;

  const ecommerceData = {
    event: 'purchaseCredits',
    ecommerce: {
      checkout: {
        actionField: { step: 2, option: 'option' }
      }
    }
  };

  dataLayer.push(ecommerceData);
};

// Checkout Behaviour Analyisis - Checkout Funnel Step 3
export const quantitySelect = () => {
  const { dataLayer } = window;

  const ecommerceData = {
    event: 'quantitySelect',
    ecommerce: {
      checkout: {
        actionField: { step: 3, option: 'option' }
      }
    }
  };

  dataLayer.push(ecommerceData);
};

// Checkout Behaviour Analyisis - Checkout Funnel Step 4
export const payPalCheckout = () => {
  const { dataLayer } = window;

  const ecommerceData = {
    event: 'payPalCheckout',
    ecommerce: {
      checkout: {
        actionField: { step: 4, option: 'option' }
      }
    }
  };

  dataLayer.push(ecommerceData);
};

// Checkout Behaviour Analyisis - Checkout Funnel Step 5
// Goal Tracking - 'User/Guest Download Image'
export const downloadSuccess = (id, user) => {
  const { dataLayer } = window;
  const eventPrefix = user ? 'user' : 'guest';

  const ecommerceData = {
    event: `${eventPrefix}DownloadSuccess`,
    ecommerce: {
      checkout: {
        actionField: { step: 5, option: 'option' },
        products: [
          {
            id
          }
        ]
      }
    }
  };

  dataLayer.push(ecommerceData);
};

// Shopping Behaviour Analysis - 'Sessions with Transactions'
// Checkout Behaviour Analyisis - Checkout Funnel Step 6
export const payPalSuccess = ({
  response: { itemPurchased, paymentId, subtotal, tax }
}) => {
  const { dataLayer } = window;

  const ecommerceData = {
    event: 'payPalSuccess',
    ecommerce: {
      purchase: {
        actionField: {
          id: paymentId,
          revenue: `${+subtotal + +tax}`,
          tax: tax
        },
        products: [
          {
            name: itemPurchased
          }
        ]
      }
    }
  };

  dataLayer.push(ecommerceData);
};

// Goal Tracking - 'Create an Account'
export const signUp = () => {
  const { dataLayer } = window;

  const goalData = {
    event: 'signUp'
  };

  dataLayer.push(goalData);
};

// Goal Tracking - 'User Log In'
export const logIn = () => {
  const { dataLayer } = window;

  const goalData = {
    event: 'logIn'
  };

  dataLayer.push(goalData);
};



// WEBPACK FOOTER //
// ./src/utils/google/index.js